import { render, staticRenderFns } from "./my-upload-hw.vue?vue&type=template&id=604e6813&scoped=true&"
import script from "./my-upload-hw.vue?vue&type=script&lang=js&"
export * from "./my-upload-hw.vue?vue&type=script&lang=js&"
import style0 from "./my-upload-hw.vue?vue&type=style&index=0&id=604e6813&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e6813",
  null
  
)

export default component.exports